import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { ApplicationFlow } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow';

const { Status } = ApplicationFlow;

export default class PleaseWaitController extends Controller {
  @service currentApplicationFlow;
  @service intl;

  @computed('currentApplicationFlow.status')
  get loadingStatus() {
    switch (this.currentApplicationFlow.status) {
      case Status.AGREEMENTS_ACCEPTED:
        return this.intl.t('sfs.signup.pleaseWait.agreementsAccepted');
      case Status.IDV_COMPLETED:
      case Status.TIN_COMPLETED:
        return this.intl.t('sfs.signup.pleaseWait.idv');
      case Status.BANK_CUSTOMER_CREATED:
        return this.intl.t('sfs.signup.pleaseWait.customer');
      default:
        return ''; // NOTE: unexpected statuses will be handled in please-wait route
    }
  }
}
